import React from 'react';
import {Stack, useTheme} from '@mui/material';
import {useSearchParams} from 'react-router-dom';

import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {HighlightedText} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages';
import {CardButton, SelectCardList} from './styles';
import {CardListProps} from './types';

const {selected: selectedLabel, select} = translations['pt-br'].others.selectionFlow;

function CardList({
	selected,
	text,
	handleClick,
	dataTagId,
	textDataTagId,
	showArrowRightIcon,
	...cardProps
}: CardListProps) {
	const [searchParams] = useSearchParams();
	const {isMobile} = useMediaQueries();
	const {colors} = useTheme();
	const query = searchParams.get('q') || '';

	return (
		<SelectCardList {...cardProps} elevation={0} selected={selected} data-tag-id={dataTagId}>
			<Stack
				p={2}
				gap={1}
				direction="row"
				justifyContent="space-between"
				alignItems="center"
				height={'100%'}
				onClick={handleClick}>
				<HighlightedText text={text} highlight={query} dataTagId={textDataTagId} />

				{isMobile || showArrowRightIcon ? (
					<Icon
						name="arrow-right"
						size={24}
						color={selected ? colors.light.success.main : colors.brand.primary.blue}
					/>
				) : (
					<CardButton
						endIcon={selected && <Icon name="success" size={20} />}
						color={selected ? 'success' : 'primary'}
						variant={selected ? 'soft' : 'text'}>
						{selected ? selectedLabel : select}
					</CardButton>
				)}
			</Stack>
		</SelectCardList>
	);
}

export {CardList};
